/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/source_canvases" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdSourceCanvases } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdSourceCanvasesResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdSourceCanvasesResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdSourceCanvases = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdSourceCanvases,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdSourceCanvasesResult> => {
    return fetch(`/decisioning_studio_agents/${appGroupId}/${dsaId}/source_canvases`, "GET", {}, { signal });
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdSourceCanvasesResult
);
